import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as cafeEventsActions from '../../../redux/cafeEvents/actions';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Spin from '../../../components/loading';
import ENUMS from '../../../enums';
import { enumHelper, domManipulator } from '../../../utils';
import styles from '../styles.scss';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

const renderStatusColors = status => {
  const {
    CONFIRMED,
    DISABLED,
    REJECTED,
    REQUESTED,
  } = ENUMS.EVENT_STATUS.values;
  switch (status) {
    case CONFIRMED:
      return 'text-success';
    case DISABLED:
      return 'text-muted';
    case REJECTED:
      return 'text-danger';
    case REQUESTED:
      return 'text-info';
    default:
      return 'text-dark';
  }
};

const CafeEventDetails = props => {
  let [reason, setReason] = useState();

  const rejectEvent = id => {
    props.rejectEvent(id, reason).then(_ => {
      const { rejectEventMessage, rejectEventFailed, rejectEventError } = props;
      if (
        rejectEventError == false &&
        rejectEventFailed == false &&
        rejectEventMessage == null
      ) {
        AlertAndConfirmation({
          title: locales('titles.editionsDoneSuccessfully'),
          text: '',
          type: 'success',
        });
        props.closeModal();
      } else {
        domManipulator.scrollToTop();
      }
    });
  };

  const confirmEvent = id => {
    props.confirmEvent(id).then(_ => {
      const {
        confirmEventMessage,
        confirmEventFailed,
        confirmEventError,
      } = props;
      if (
        confirmEventError == false &&
        confirmEventFailed == false &&
        confirmEventMessage == null
      ) {
        AlertAndConfirmation({
          title: locales('titles.editionsDoneSuccessfully'),
          text: '',
          type: 'success',
        });
        props.closeModal();
      } else {
        domManipulator.scrollToTop();
      }
    });
  };

  const disableEvent = id => {
    props.disableEvent(id).then(_ => {
      const {
        disableEventMessage,
        disableEventFailed,
        disableEventError,
      } = props;
      if (
        disableEventError == false &&
        disableEventFailed == false &&
        disableEventMessage == null
      ) {
        props.closeModal();
      } else {
        domManipulator.scrollToTop();
      }
    });
  };

  useEffect(() => {
    props.fetchCafeEventDetailsById(props.eventId);
  }, []);

  const {
    cafeEventDetailsLoading,
    cafeEventDetailsError,
    cafeEventDetailsFailed,
    cafeEventDetailsMessage,
    cafeEventDetails,

    disableEventError,
    disableEventFailed,
    disableEventLoading,
    disableEventMessage,

    confirmEventError,
    confirmEventFailed,
    confirmEventLoading,
    confirmEventMessage,

    rejectEventError,
    rejectEventFailed,
    rejectEventMessage,
    rejectEventLoading,

    isFromRseeRequesteds,
    isFromArchived,
  } = props;

  const {
    hourlyWeekDaysEventsList,
    cafeName,
    createdAt,
    name,
    id,
    updatedFullName,
    updatedAt,
    createdFullName,
    fromDate,
    toDate,
    rejectionReason,
    status,
  } = cafeEventDetails;

  const eventDays =
    hourlyWeekDaysEventsList && hourlyWeekDaysEventsList.length
      ? [...new Set(hourlyWeekDaysEventsList.map(item => item.weekday))]
      : [];

  return (
    <>
      <Modal id='financial-transaction-modal' size='xl' isOpen={props.isOpen}>
        <ModalHeader>
          <div className='row'>
            <div className='col-11'>{name}</div>
            <div className='col-1 text-left'>
              <a
                href='#'
                className=''
                onClick={event => {
                  event.preventDefault();
                  props.closeModal();
                }}
              >
                <i className='fas fa-times'></i>
              </a>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          <Spin
            spinning={
              cafeEventDetailsLoading ||
              disableEventLoading ||
              confirmEventLoading ||
              rejectEventLoading
            }
          >
            {(cafeEventDetailsError ||
              disableEventError ||
              confirmEventError ||
              rejectEventError) && (
              <div className='alert alert-danger'>
                {locales('messages.server.error')}
              </div>
            )}
            {(cafeEventDetailsFailed ||
              disableEventFailed ||
              confirmEventFailed ||
              rejectEventFailed) && (
              <div className='alert alert-danger'>
                {cafeEventDetailsMessage ||
                  disableEventMessage ||
                  confirmEventMessage ||
                  rejectEventMessage}
              </div>
            )}
            <article className='col-12'>
              <div className='col-12 p-0 py-1 font-weight-bold text-dark'>
                {locales('titles.eventBasicInfo')}
              </div>

              <div className='col-12 border rounded py-2 px-1'>
                <div className='col-12 d-flex py-2 px-1'>
                  <div className='col-4 d-flex align-items-center'>
                    <div className='col-5 text-muted'>
                      {locales('titles.creatorName')} :{' '}
                    </div>
                    <div className='col-7 text-dark font-weight-bold font-large'>
                      {createdFullName}
                    </div>
                  </div>
                  <div className='col-4 d-flex justify-content-end align-items-center p-0'>
                    <div className='col-5 text-left text-muted'>
                      {locales('tables.lastUpdate')} :{' '}
                    </div>
                    <div className='col-7 text-dark font-weight-bold font-large'>
                      {updatedAt}
                    </div>
                  </div>
                  <div className='col-4 d-flex justify-content-end align-items-center p-0'>
                    <div className='col-5 text-muted'>
                      {locales('tables.status')} :{' '}
                    </div>
                    <div
                      className={`${renderStatusColors(
                        status,
                      )} col-7 text-dark font-weight-bold font-large`}
                    >
                      {enumHelper.convertEnumValueToTitle(
                        ENUMS.EVENT_STATUS.list,
                        status,
                      )}
                    </div>
                  </div>
                </div>

                <div className='col-12 d-flex py-2 px-1 my-2'>
                  <div className='col-4 d-flex  align-items-center'>
                    <div className='col-5 text-muted'>
                      {locales('fields.requestTime')} :{' '}
                    </div>
                    <div className='col-7 text-dark font-weight-bold font-large'>
                      {createdAt}
                    </div>
                  </div>

                  <div className='col-4 d-flex align-items-center'>
                    <div className='col-5 text-muted text-center mx-2'>
                      {locales('fields.cafe.name')} :{' '}
                    </div>
                    <div className='col-7 text-dark font-weight-bold font-large'>
                      {cafeName}
                    </div>
                  </div>
                  <div className='col-4 d-flex align-items-center p-0'>
                    <div className='col-6 text-muted'>
                      {locales('tables.updatorFullName')} :{' '}
                    </div>
                    <div className='col-6 text-dark font-weight-bold font-large'>
                      {updatedFullName}
                    </div>
                  </div>
                </div>

                <div className='col-12 d-flex py-2 px-1 my-2'>
                  <div className='col-4 d-flex  align-items-center'>
                    <div className='col-5 text-muted'>
                      {locales('tables.creditFrom')} :{' '}
                    </div>
                    <div className='col-7 text-dark font-weight-bold font-large'>
                      {fromDate}
                    </div>
                  </div>

                  <div className='col-4 d-flex align-items-center'>
                    <div className='col-5 text-muted text-center mx-2'>
                      {locales('tables.creditTo')} :{' '}
                    </div>
                    <div className='col-7 text-dark font-weight-bold font-large'>
                      {toDate}
                    </div>
                  </div>
                  <div className='col-4 d-flex align-items-center p-0'>
                    <div className='col-6 text-muted'>
                      {locales('labels.rejectionReason')} :{' '}
                    </div>
                    <div className='col-6 text-dark font-weight-bold font-large'>
                      {rejectionReason}
                    </div>
                  </div>
                </div>
              </div>

              {isFromRseeRequesteds && (
                <textarea
                  className='my-3 form-control'
                  value={reason}
                  onChange={event => setReason(event.target.value)}
                  placeholder={locales('labels.rejectionReason')}
                ></textarea>
              )}
              <table
                className={`table table-striped table-hover table-light table-bordered my-3  ${styles['table-row-overflow']}`}
              >
                <thead>
                  <tr>
                    <th className='text-center'>
                      {locales('fields.week.day')}
                    </th>
                    <th className='text-center'>{locales('fields.hours')}</th>
                  </tr>
                </thead>
                <tbody>
                  {eventDays.map(event => (
                    <tr key={event}>
                      <td className='text-center'>
                        {enumHelper.convertEnumValueToTitle(
                          ENUMS.WEEK_DAYS.list,
                          event,
                        )}
                      </td>
                      <td className='text-center'>
                        <div className='d-flex justify-content-center'>
                          {[
                            ...hourlyWeekDaysEventsList.filter(
                              item => item.weekday == event,
                            ),
                          ].map(item => (
                            <React.Fragment key={item.id}>
                              <div className='px-3'>
                                <div className='px-3'>{`${item.toTime}-${item.fromTime}`}</div>
                              </div>
                            </React.Fragment>
                          ))}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </article>
          </Spin>
        </ModalBody>
        <ModalFooter>
          <button className='btn btn-light' onClick={() => props.closeModal()}>
            {locales('labels.close.modal')}
          </button>
          {isFromRseeRequesteds && (
            <>
              <button
                className='btn btn-danger'
                onClick={() => rejectEvent(id)}
              >
                {locales('titles.rejectComment')}
              </button>
              <button className='btn btn-info' onClick={() => confirmEvent(id)}>
                {locales('tables.approve')}
              </button>
            </>
          )}
          {isFromArchived && status == ENUMS.EVENT_STATUS.values.CONFIRMED && (
            <button
              className='mx-1 btn btn-secondary'
              onClick={() => disableEvent(id)}
            >
              {locales('labels.disable.cafe')}
            </button>
          )}
        </ModalFooter>
      </Modal>
    </>
  );
};
const mapStateToProps = state => {
  return {
    cafeEventDetails: state.cafeEventsReducer.cafeEventDetails || {},
    cafeEventDetailsLoading: state.cafeEventsReducer.cafeEventDetailsLoading,
    cafeEventDetailsMessage: state.cafeEventsReducer.cafeEventDetailsMessage,
    cafeEventDetailsFailed: state.cafeEventsReducer.cafeEventDetailsFailed,
    cafeEventDetailsError: state.cafeEventsReducer.cafeEventDetailsError,

    disableEventLoading: state.cafeEventsReducer.disableEventLoading,
    disableEventMessage: state.cafeEventsReducer.disableEventMessage,
    disableEventError: state.cafeEventsReducer.disableEventError,
    disableEventFailed: state.cafeEventsReducer.disableEventFailed,

    confirmEventLoading: state.cafeEventsReducer.confirmEventLoading,
    confirmEventMessage: state.cafeEventsReducer.confirmEventMessage,
    confirmEventError: state.cafeEventsReducer.confirmEventError,
    confirmEventFailed: state.cafeEventsReducer.confirmEventFailed,

    rejectEventLoading: state.cafeEventsReducer.rejectEventLoading,
    rejectEventMessage: state.cafeEventsReducer.rejectEventMessage,
    rejectEventError: state.cafeEventsReducer.rejectEventError,
    rejectEventFailed: state.cafeEventsReducer.rejectEventFailed,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchCafeEventDetailsById: id =>
      dispatch(cafeEventsActions.fetchCafeEventDetailsById(id)),
    disableEvent: id => dispatch(cafeEventsActions.disableEvent(id)),
    rejectEvent: (id, reason) =>
      dispatch(cafeEventsActions.rejectEvent(id, reason)),
    confirmEvent: id => dispatch(cafeEventsActions.confirmEvent(id)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CafeEventDetails);
